import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import expertRessourcesAnimerLaFormationStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'expertRessourcesAnimerLaFormation'
const customImplement: CustomStoreImplementationOptions = expertRessourcesAnimerLaFormationStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function expertRessourcesAnimerLaFormationFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('expert-ressource-6-animation-de-la-format.title', 'Animer la formation'),
        $description: $translate('expert-ressource-6-animation-de-la-format.description', 'Vous allez intervenir pour la première fois comme formateur ? Découvrez nos conseils pour animer la formation. Matchers vous livre ses meilleurs conseils pour bien démarrer la formation. Découvrez également les différents types d\'apprentissage et pourquoi un adulte n\'apprend pas comme un enfant  !'),
        $publishedTime: new Date('2023-08-01T13:10:04.774Z'),
        $modifiedTime: new Date('2023-09-07T09:41:34.158Z'),
        // Constants,
        $constants: {
          previewRessourceShortTitle: '<p><span style="color:#D93174FF;">&gt; &nbsp; Comment rédiger mon support de formation ?&nbsp;</span></p>',
          question1Hidden: false,
          question1Hidden1: null
        },
        // Data,
        $info: { expertRessource6AnimationDeLaFormat: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async toutesLesRessourcesClick () {
        await navigateTo({ name: 'hub-expert-Ressources' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async previewRessourceShortClick () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClick () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      deroulentClickWhenSelected () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      async element1Click () {
        await navigateTo({ name: 'Expert-Ressources-posture-du-formateur' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element2Click () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element3Click () {
        await navigateTo({ name: 'hub-expert-Ressources-preparer-rdv-decouverte' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element4Click () {
        await navigateTo({ name: 'hub-expert-Ressources-rediger-programme-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return expertRessourcesAnimerLaFormationFactory(storeId)()
}

export const expertRessourcesAnimerLaFormationRaw = expertRessourcesAnimerLaFormationFactory()
export const expertRessourcesAnimerLaFormation = () => expertRessourcesAnimerLaFormationRaw() as MergeCustomStore<typeof expertRessourcesAnimerLaFormationStoreCustom.instance>
